import { render, staticRenderFns } from "./burger-menu.vue?vue&type=template&id=6e105de4"
import script from "./burger-menu.vue?vue&type=script&lang=js"
export * from "./burger-menu.vue?vue&type=script&lang=js"
import style0 from "./burger-menu.vue?vue&type=style&index=0&id=6e105de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports